/**
 * WooVariationToggle
 * ======================================
 * - toggle
 */

const ELEMENTS = '.js-WooVariationToggle'
const CLASS = 'is-toggled'

class WooVariationToggle {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    this.elements.forEach((el) => {
      el.addEventListener('click', this.clickHandler, false)
    })

    // dynamic bind for woo checkout
    document.body.addEventListener( 'click', function ( event ) {
      if( event.target.classList.contains('js-WooVariationToggle')) {
        event.target.classList.add(CLASS)
      };
    } );
  }

  clickHandler = (e) => {
    const el = e.currentTarget;
    el.classList.add(CLASS)
  }

}

new WooVariationToggle()
